import { render, staticRenderFns } from "./SwiftPaymentsReview.vue?vue&type=template&id=8619b0fc"
import script from "./SwiftPaymentsReview.vue?vue&type=script&lang=js"
export * from "./SwiftPaymentsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports